import { createGlobalState } from 'react-use';

import { PurchaseId } from '@dreryk/egabinet-financial-settlement-published-language-api';

import { ObjectMap } from '~libs.typescript';

type MedicalServicesCount = number;
type MedicalServicesCounterState = Array<[PurchaseId, MedicalServicesCount]>;

type MedicalServicesCounterGetter = (purchaseId: PurchaseId) => MedicalServicesCount;
type MedicalServicesCounterUpdater = (newState: MedicalServicesCounterState) => void;
type MedicalServicesCounterReset = VoidFunction;

const useGlobalState = createGlobalState(new ObjectMap<PurchaseId, MedicalServicesCount>());

type UseMedicalServicesCounterGlobalStateReturnFn = {
   getCounter: MedicalServicesCounterGetter;
   updateState: MedicalServicesCounterUpdater;
   resetCounter: MedicalServicesCounterReset;
};

export const useMedicalServicesCounterGlobalState = (): UseMedicalServicesCounterGlobalStateReturnFn => {
   const [globalState, setGlobalState] = useGlobalState();

   const getCounter: MedicalServicesCounterGetter = (purchaseId) => {
      return globalState.get(purchaseId) ?? 0;
   };

   const resetCounter: MedicalServicesCounterReset = () => {
      setGlobalState(new ObjectMap());
   };

   const updateState: MedicalServicesCounterUpdater = (newState) => {
      setGlobalState(new ObjectMap([...globalState, ...newState]));
   };

   return {
      getCounter: getCounter,
      updateState: updateState,
      resetCounter: resetCounter,
   };
};
